import { render, staticRenderFns } from "./main-products.vue?vue&type=template&id=d8ee0f4e&scoped=true&"
import script from "./main-products.vue?vue&type=script&lang=js&"
export * from "./main-products.vue?vue&type=script&lang=js&"
import style0 from "./main-products.vue?vue&type=style&index=0&id=d8ee0f4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ee0f4e",
  null
  
)

export default component.exports